// models/Company.ts
export class Company {
    id: number;
    companyName?: string;
    companyFullName?: string;
    companyFullNameKhmer?: string;
    companyLogoPath?: string;
    primaryColor: string;
    theme?: string;
    isExpired?: boolean;

    constructor(
        id: number,
        primaryColor: string,
        companyName?: string,
        companyFullName?: string,
        companyFullNameKhmer?: string,
        companyLogoPath?: string,
        theme?: string,
        isExpired?: boolean
    ) {
        this.id = id;
        this.primaryColor = primaryColor;
        this.companyName = companyName;
        this.companyFullName = companyFullName;
        this.companyFullNameKhmer = companyFullNameKhmer;
        this.companyLogoPath = companyLogoPath;
        this.theme = theme;
        this.isExpired = isExpired;
    }

    // A method to parse JSON into a Company instance
    static fromJSON(json: any): Company {

        if (!json) {
            return new Company(1, '#fdad64', 'NSM', 'NSM SOLUTION AND MAINTENANCE CO.,LTD', 'ក្រុមហ៊ុន អិនអេសអិម សឹលូសិន អេន មេថឹណិន ឯ.ក', 'NSM-LOGO.png', 'ORANGE_THEME');
        }

        return new Company(
            json.id,
            json.primaryColor,
            json.companyName,
            json.companyFullName,
            json.companyFullNameKhmer,
            json.companyLogoPath,
            json.theme,
            json.isExpired
        );
    }
}
